export default __webpack_public_path__ + "static/media/Group 161.c4f61f7b.png";